import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {httpLoaderFactory} from '../../app.module';
import {CdkDrag, CdkDragHandle, DragDropModule} from '@angular/cdk/drag-drop';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {BrowserModule} from '@angular/platform-browser';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { AppTaskNodeCreateFormComponent } from './task-options/forms/task-node-create-edit-form/task-node-create-edit-form';
import { AppTaskEdgeCreateFormComponent } from './task-options/forms/task-node-create-edge-form/task-node-create-edge-form';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ComponentsModule } from '../../components/components.module';
import { AppBoardMngtFormComponent } from './forms/board-mngt-form/board-mngt-form';
import { AppTaskMngtFormComponent } from './forms/task-mngt-form/task-mngt-form';
import { AppTaskDashboardsV3Component } from './task-dashboards-v3/task-dashboards-v3.component';
import { MatExpansionModule } from '@angular/material/expansion';
@NgModule({
    declarations: [
      AppTaskNodeCreateFormComponent,
      AppTaskEdgeCreateFormComponent,
      AppBoardMngtFormComponent,
      AppTaskDashboardsV3Component,
      AppTaskMngtFormComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        BrowserModule,
        FormsModule,
        CdkDrag,
        CdkDragHandle,
        DragDropModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        MatExpansionModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatSelectModule,
        MatTooltip,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'ru',
        })
    ],

    exports: [
      AppTaskNodeCreateFormComponent,
      AppTaskEdgeCreateFormComponent,
      AppBoardMngtFormComponent,
      AppTaskDashboardsV3Component,
      AppTaskMngtFormComponent
    ],
    providers: []
})
export class AppTasksModule {
}
